module.exports = __webpack_public_path__ + "media/images/policies/step4-bb5f9a4fc044452affc1b4e3a427613b.svg";